import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';
import MediaQuery from 'react-responsive';
import ReactCollapse from 'react-collapse';

import PrivacyPolicy from 'login/components/Library/PrivacyPolicy/PrivacyPolicy.jsx';

import 'login/components/GuestOrSignin/components/GuestSection/GuestSection.scss';

class GuestSection extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedOption: 'signup',
            sectionOpened: false,
        };

        this.onSelectionChange = this.onSelectionChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onOpenSection = this.onOpenSection.bind(this);
    }

    onSelectionChange(option) {
        this.setState({
            selectedOption: option,
        });
    }

    onSubmit() {
        this.props.onSelection(this.state.selectedOption);
    }

    onOpenSection() {
        this.setState({
            sectionOpened: !this.state.sectionOpened,
        });
    }

    render() {
        const sectionContent = (
            <form>
                <div className="connection-options">
                    <input
                        type="radio"
                        id="new-customer"
                        name="new-customer"
                        value="signup"
                        checked={this.state.selectedOption === 'signup'}
                        onChange={() => this.onSelectionChange('signup')}
                    />
                    <label htmlFor="new-customer">
                        <span className="sr-text is-bold">{LocaleService.t('LOGIN.GUEST_SECTION.CREATE_ACCOUNT')}</span>
                        <ul className="accountPrivileges--listing">
                            <li className="accountPrivileges--single">
                                {LocaleService.t('LOGIN.GUEST_SECTION.SAVE_VEHICLE_YOUR_GARAGE')}
                            </li>
                            <li className="accountPrivileges--single">
                                {LocaleService.t('LOGIN.GUEST_SECTION.SAVE_PREFERENCES')}
                            </li>
                            <li className="accountPrivileges--single">
                                {LocaleService.t('LOGIN.GUEST_SECTION.GET_BEST_DEAL')}
                            </li>
                        </ul>
                    </label>
                </div>
                <div className="connection-options">
                    <input
                        type="radio"
                        id="guest-customer"
                        name="new-customer"
                        value="guest"
                        checked={this.state.selectedOption === 'guest'}
                        onChange={() => this.onSelectionChange('guest')}
                    />
                    <label htmlFor="guest-customer" className="sr-text is-bold">
                        <span className="sr-text is-bold">
                            {LocaleService.t('LOGIN.GUEST_SECTION.CONTINUE_AS_GUEST')}
                        </span>
                    </label>
                </div>
                <br />
                <button type="button" onClick={this.onSubmit} className="sr-button-1 is-small">
                    {LocaleService.t('LOGIN.GUEST_SECTION.BUTTON_TITLE')}
                </button>
                <PrivacyPolicy />
            </form>
        );
        const openSectionIcon = this.state.sectionOpened ? 'icon-chevron-thin-down reverse' : 'icon-chevron-thin-down';

        return (
            <div className="guest-section">
                <h3 className="sr-title-1 is-centered" onClick={this.onOpenSection}>
                    <icon className={openSectionIcon} />
                    {LocaleService.t('LOGIN.GUEST_SECTION.TITLE')}
                </h3>
                <MediaQuery maxWidth={767}>
                    <ReactCollapse isOpened={this.state.sectionOpened} springConfig={{ stiffness: 170, damping: 29 }}>
                        {sectionContent}
                    </ReactCollapse>
                </MediaQuery>
                <MediaQuery minWidth={767}>{sectionContent}</MediaQuery>
            </div>
        );
    }
}

GuestSection.propTypes = {
    onSelection: PropTypes.func.isRequired,
};

GuestSection.displayName = 'GuestSection';

export default GuestSection;
